/**
 * Shipping Progress Bar
 * Fetches cart total and updates the progress bar toward free shipping threshold.
 * Supports 3 message states: initial (empty cart), remaining, reached.
 */
(function () {
  'use strict';

  function formatEuros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateBars(cartTotalCents) {
    document.querySelectorAll('.shipping-bar').forEach(function (bar) {
      var thresholdCents = parseInt(bar.dataset.threshold, 10);
      var msgInitial = bar.dataset.msgInitial || '';
      var msgRemaining = bar.dataset.msgRemaining || '';
      var msgReached = bar.dataset.msgReached || '';
      var messageEl = bar.querySelector('[data-shipping-message]');
      var fillEl = bar.querySelector('[data-shipping-fill]');

      if (!messageEl || !fillEl) return;

      if (cartTotalCents >= thresholdCents) {
        // Threshold reached
        messageEl.textContent = msgReached;
        fillEl.style.width = '100%';
      } else if (cartTotalCents === 0) {
        // Cart empty — show initial message with full threshold
        messageEl.textContent = msgInitial.replace('[amount]', formatEuros(thresholdCents));
        fillEl.style.width = '0%';
      } else {
        // Cart partially filled — show remaining amount
        var remainingCents = thresholdCents - cartTotalCents;
        messageEl.textContent = msgRemaining.replace('[amount]', formatEuros(remainingCents));
        var pct = Math.min((cartTotalCents / thresholdCents) * 100, 100);
        fillEl.style.width = pct + '%';
      }
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBars(cart.total_price);
      })
      .catch(function (err) {
        console.error('Shipping bar: cart fetch failed', err);
      });
  }

  // Initial load
  fetchCartAndUpdate();

  // Listen for custom cart update events
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('shopify:section:load', fetchCartAndUpdate);

  // Intercept fetch calls to cart mutation endpoints to auto-refresh
  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var isCartMutation =
      typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1);

    var result = originalFetch.apply(this, arguments);

    if (isCartMutation) {
      result.then(function () {
        setTimeout(fetchCartAndUpdate, 300);
      });
    }

    return result;
  };

  // Also intercept XMLHttpRequest for themes using jQuery.ajax
  var originalXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (
      typeof url === 'string' &&
      (url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1)
    ) {
      this.addEventListener('load', function () {
        setTimeout(fetchCartAndUpdate, 300);
      });
    }
    return originalXHROpen.apply(this, arguments);
  };
})();
